import React from 'react';
import PropTypes from 'prop-types';
import ValuePropsModal from './ValuePropsModal';
import { FormattedMessage } from 'react-intl';
import Lists from 'images/Lists@2x.jpg';

const formattedTitle = (
  <FormattedMessage
    id="ValueProps.taskListAssign.title"
    description="Assign checklists value prop title"
    defaultMessage="Assign Checklists"
  />
);

const formattedDescription = (
  <FormattedMessage
    id="ValueProps.taskListAssign.description"
    description="Description for Assign checklists Feature"
    defaultMessage="Keep your crew accountable and productive"
  />
);

const taskListAssignChecklist = [
  <FormattedMessage
    id="ValueProps.taskListAssign.valuePropA"
    description="Value Prop for Assign checklists Feature"
    defaultMessage="Assign a checklist to one or more users on your account"
  />,
  <FormattedMessage
    id="ValueProps.taskListAssign.valuePropB"
    description="Value Prop for Assign checklists Feature"
    defaultMessage="Assigned users get a notification on their device, letting them know there's work to do"
  />,
  <FormattedMessage
    id="ValueProps.taskListAssign.valuePropC"
    description="Value Prop for Assign checklists Feature"
    defaultMessage="Avoid 'oh, crap, I forgot to do that' mistakes. Hey, we all make 'em"
  />,
];

const TaskListAssignValuePropsModal = ({ isOpen, onRequestClose }) => {
  return (
    <ValuePropsModal
      title={formattedTitle}
      image={Lists}
      description={formattedDescription}
      checklistItems={taskListAssignChecklist}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      trialed={false}
    />
  );
};

export default TaskListAssignValuePropsModal;

TaskListAssignValuePropsModal.propTypes = {
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func,
};
